export interface AuthAPIError {
  error_class: string;
  type: AuthAPIErrorType;
  message: string;
}

export enum AuthAPIErrorType {
  NOT_LOGGED_IN = "NOT_LOGGED_IN_ERROR",
  PERMISSION_DENIED = "PERMISSION_DENIED_ERROR",
  TOKEN_EXPIRED = "TOKEN_EXPIRED_ERROR",
  OTHER_ERROR = "OTHER_ERROR",
}
